import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageSelectionComponent } from './component/language-selection.component';
import { MaterialModule } from '@sdbn/appclient';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { TapableTerminalCardModule } from '../tabbable-terminal-card/tapable-terminal-card.module';
import { CenteredScrollableContentModule } from '../centered-scrollable-content/centered-scrollable-content.module';


@NgModule({
  declarations: [
    LanguageSelectionComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ApplicationClientCommonModule,
    TapableTerminalCardModule,
    CenteredScrollableContentModule
  ]
})
export class LanguageSelectionModule {

 }
